import '../sass/style.scss';

import 'imports-loader?define=>false!animation.gsap';
import ScrollMagic from 'ScrollMagic';

import { $, $$ } from './lib/bling';

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

// load our helper functions
const h = require('./helpers');

const defaults = {
    offset() {
        return  0 - (h.viewportHeight() * 0.25);
    },
    offsetLarge() {
        return  0 - (h.viewportHeight() * 1);
    },
    imageDuration() {
        return  h.viewportHeight() * 0.5;
    },
    imageDurationLarge() {
        return  h.viewportHeight() * 0.75;
    },
    imageDurationFull() {
        return  h.viewportHeight();
    }
}

// create our scroll magic instance
let scroll;

// we need to monitor our screen width in order to rebuid our svgs that are screen width dependent
let windowWidth = h.viewportWidth();

// set a flag to use to throttle callback functions
let resizeInProgress = false;
const resizing = () => {


    if (!resizeInProgress) {
        
        resizeInProgress = true; // throttle this function
        
        setTimeout(function() {
            
            if (detectIE()) {
                setHeightOfSVGContainers();
            }
            
            resizeInProgress = false;

        }, 50);

    }


}

const randomiser = {

    length : 0,
    keys : null,
    to : null,
    max: 400,
    min: 250,
    itemClass: 'scanItem',
    modifiedClass: 'scanItem--active',
    init() {
        this.keys = $$(`.${this.itemClass}`);
        this.length = this.keys.length - 1;
    },
    randomKey() {
        if (this.length > 2) {
            const num = Math.floor(Math.random() * this.length);
            return num;
        }
        return false;
    },
    start() {

        if (detectIE()) {
            return false;
        }

        const num = this.randomKey();
        const i = this;
        if (num) {
            this.keys[num].classList.add(i.modifiedClass)
            setTimeout(function() {
                i.keys[num].classList.remove(i.modifiedClass)
            }, Math.floor(Math.random()*(i.max-i.min+1)+i.min));
        }
        this.to = setTimeout(function() {
            i.start()
        }, Math.floor(Math.random()*(i.max-i.min+1)+i.min));
    },
    stop() {
        clearTimeout(this.to);
    }
};


// the function to set our animations!
const setUpAnimations = () => {

    let scenes = []; // we will add our scens to this container as we create them


    // create our container...
    scroll = new ScrollMagic.Controller();

    /**
     * Animate the intro graphic 
     */
    
    const introAnimation = new TimelineMax();
    introAnimation
        .set('#introAnimation', { visibility: 'visible', y: '+=19%', opacity: 0 })
        .to('#introAnimation', 0.3, { opacity: 1 })
        .to('#introAnimation', 1.5, { y: '-=19%', ease: Power2.easeInOut })
    

    const animateIntroClock = new TimelineMax( { repeat: -1 } );
    animateIntroClock
        .set(['#clockArmMinute_2_', '#clockArmHour_2_'], { transformOrigin: '50% 50%'})
        .to('#clockArmMinute_2_', 6, { rotation: 2160, ease: Linear.easeNone }, 0)
        .to('#clockArmHour_2_', 6, { rotation: 360, ease: Linear.easeNone }, 0)


    /**
     * Animate all the incrementing numbers
     */

    // array of ids containing the numbers to animate
    const animatingNumbers = [];

    // loop through ids and increment
    animatingNumbers.forEach(function(id) {

        const num = { var: 0 };
        const cd = TweenMax.to(num, 1, {
            var: parseInt($(`#${id}`).getAttribute('data-target')), 
            onUpdate: function () {
                $(`#${id}`).innerHTML = Math.ceil(num.var);
            },
            ease:Circ.easeOut
        });   

        const countdown = new ScrollMagic.Scene({
            triggerElement: `#${id}`,
            offset: defaults.offset()
        }).setTween(cd);
        
        // add it to our scenes holder
        scenes.push(countdown);

    });

    /**
     * Scene One
     */
    
    if (!detectIE()) {
        const iconServiceCentre = new TimelineMax({ repeat: -1, repeatDelay: 0 });  
           iconServiceCentre
            .set('#iconServiceCentreServ4', { transformOrigin : '50% 50%' })
            .to('#iconServiceCentreServ1', 0.5, { x: '+=128', y: '-=50', scale: 1.44})
            .to('#iconServiceCentreServ2', 0.5, { x: '+=53.8', y: '-=23.4', scale: 1.2})
            .to('#iconServiceCentreServ3', 0.5, { x: '+=45', y: '-=20', scale: 1.2})
            .fromTo('#iconServiceCentreServ4', 0.5, { visibility: 'hidden' }, { visibility: 'visible', x: '+=42', y: '-=5.1', scale: 1.2 });       
    }

   
    // animate the steering wheel
    const animateSteeringWheel = new TimelineMax({ repeat: -1, repeatDelay: 1 });
    animateSteeringWheel
        .set('#iconServiceSteeringWheel', { transformOrigin: '50% 50%' })
        .to('#iconServiceSteeringWheel', 0.5, { rotation: 45, ease: Power2.easeOut })
        .to('#iconServiceSteeringWheel', 0.5, { rotation: 0, ease: Power2.easeOut }, '+=1')
        .to('#iconServiceSteeringWheel', 0.5, { rotation: -45, ease: Power2.easeOut }, '+=1')
        .to('#iconServiceSteeringWheel', 0.5, { rotation: 0, ease: Power2.easeOut }, '+=1')


    // animate the bardcode scanner
    const animateBarcodeScanner = new TimelineMax( { repeat: -1 });
    animateBarcodeScanner
        .set('#BarcodeScannerLine', { y: -55, rotation: -19, x: 25, opacity: 0.4, visibility: 'visible' })
        // .set('#BarcodeScannerLine', { y: 15, rotation: 7, x: 1 })
        .to('#BarcodeScannerLine', 2, { y: 12, rotation: 6, x: 15, ease: Linear.easeNone })
        .to('#BarcodeScannerLine', 2, { y: -55, rotation: -19, x: 25, ease: Linear.easeNone })

    const animateBarcodeScanner2 = new TimelineMax( { repeat: -1, paused: false });
    animateBarcodeScanner2
        .set('#BarcodeScannerLine2', { y: 12, rotation: 6, x: 15, opacity: 0.4, visibility: 'visible' })
        // .set('#BarcodeScannerLine', { y: 15, rotation: 7, x: 1 })
        .to('#BarcodeScannerLine2', 2, { y: -55, rotation: -19, x: 25, ease: Linear.easeNone })
        .to('#BarcodeScannerLine2', 2, { y: 12, rotation: 6, x: 15, ease: Linear.easeNone })



    const randomBarcode = randomiser;
    randomBarcode.itemClass = 'scanItem';
    randomBarcode.modifiedClass = 'scanItem--active';
    randomBarcode.init();
    randomBarcode.start();
    // and launch a second instance
    randomBarcode.start();



    
    // animate the hour glass
    const animateHourGlass = new TimelineMax( { repeat: -1 } );
    animateHourGlass
        .set(['#Hourglass_1_', '#insideUp'], { transformOrigin: '50% 50%' })
        .set('#insideDown', { visibility: 'visible', opacity: 0 })
        .to('#insideUpCircles', 3, { y : '+=50%', ease: Linear.easeNone })
        .to('#Hourglass_1_', 0.5, { rotation: 180 }, 3)
        .to('#insideUp', 0.4, { opacity: 0, y: '-=8' }, 3.1)
        .to('#insideDown', 0.4, { opacity: 1 }, 3.1)

    const animateScrollingPaper = new TimelineMax();
    animateScrollingPaper
        .set('#paperMain', { y: '+=120' })
        .to('#backOfPaper', 2, { attr : { height: '-=120', y: '+=120' } }, 0)
        .to('#paperMain', 2, { y: 0 }, 0)

    const animateScrollingPaperScene = new ScrollMagic.Scene({
        triggerElement: '#s1t3',
        duration: defaults.imageDurationFull(),
        triggerHook: 0.7
    }).setTween(animateScrollingPaper)

    scenes.push(animateScrollingPaperScene);




    // database plug and play
    const animatePlugAndPlay = new TimelineMax( { repeat: -1 });
    animatePlugAndPlay
        .set('#db4', { y : '-25', visibility: 'visible'})
        .to('#DatabaseContainer', 1, { x: '-=67', ease: Power2.easeInOut })
        .to('#db4', 0.5, { y: 0 })
    

    // money saving
    const animateMoneySaving = new TimelineMax( { repeat: -1, repeatDelay: 0.5 });
    animateMoneySaving
        .set('#iconDialPerformancePointerWithSq', { transformOrigin: '50% 50%', rotation: -180, visibility: 'visible' })
        .set('#coin', { visibility: 'visible', y: '-=150' })
        .to('#iconDialPerformancePointerWithSq', 1, { rotation: '+=90', ease: Back.easeOut.config(2) }, 0.5)
        .to('#coin', 0.5, { y: '+=180', ease: Power2.easeOut })
        .to('#iconDialPerformancePointerWithSq', 1, { rotation: 0, ease: Back.easeInOut.config(2) })
        .to('#coin', 0, { y: '-=180', visibility: 'hidden' })
        .to('#coin', 0.5, { y: '+=180', visibility: 'visible', ease: Power2.easeOut })
        .to('#iconDialPerformancePointerWithSq', 1, { rotation: -180, ease: Back.easeInOut.config(1) })



    /**
     * Scene Two
     */
    const animateUSBStick = new TimelineMax();
    animateUSBStick
        .set(['#usb', '#dbBottomBit', '#dbMiddleBit', '#dbTopBit'], { visibility: 'visible', y: '+=178' })
        .to('#dbTopBit', 0.5, { y: 0, ease: Power4.easeOut }, 0.5 )
        .to('#dbMiddleBit', 0.5, { y: 0, ease: Power4.easeOut } )
        .to('#dbBottomBit', 0.5, { y: 0, ease: Power4.easeOut } )
        .to('#usb', 0.5, { y: 0, ease: Power4.easeOut } )
        .fromTo('#lock', 0.5, { scale: 2, visibility: 'hidden', transformOrigin: '50% 50%' }, { scale: 1, visibility: 'visible', ease: Back.easeOut.config(3) })
        .add('startPlugAndPlay', '+=0.5')
        .to(['#dbUSB', '#lock'], 1, { y: '+=33', ease: Power4.easeOut }, 'startPlugAndPlay')
        .to('#usb', 0, { visibility: 'hidden' }, 'startPlugAndPlay+=1')

    const animateUSBStickScene = new ScrollMagic.Scene({
        triggerElement: '#s2t1',
        triggerHook: 0.8
    }).setTween(animateUSBStick)

    scenes.push(animateUSBStickScene);


    /**
     * Scene Three
     */

     const animateBullseye = new TimelineMax();
     animateBullseye

        .set('#arrowEndPosition', { visibility: 'visible', x: '+=180', y: '-=180' })
        .set(['#mark1', '#mark2'], { transformOrigin: '50% 50%', visibility : 'visible', scale: 0 })
        .to('#arrowEndPosition', 0.5, { x: 0, y: 0, ease: Power4.easeIn })
        .add('arrowFired')
        .to('#mark1', 0.2, { scale: 1, ease: Back.easeOut.config(2) }, 'arrowFired')
        .to('#mark2', 0.2, { scale: 1, ease: Back.easeOut.config(2) }, 'arrowFired')
        .to('#serverBullseyeStatus', 0.5, { fill: 'green', ease: Elastic.easeOut.config(1, 0.3) }, 'arrowFired')


    const animateBullseyeScene = new ScrollMagic.Scene({
        triggerElement: '#s3t1',
        triggerHook: 0.8
    }).setTween(animateBullseye)

    scenes.push(animateBullseyeScene);


    const animateBullseyeDots = new TimelineMax({ paused: true, repeat: -1 });

    animateBullseyeDots
        .set(['#bullseyeDot1', '#bullseyeDot2'], { 
            visibility: 'visible', transformOrigin: '50% 50%', 
            scale: 0 
        })
        .set(['#bullseyeDot5', '#bullseyeDot4'], { 
            visibility: 'visible', transformOrigin: '50% 50%', 
            scale: 0.5 
        })
        .set(['#bullseyeDot3', '#bullseyeDot6'], { 
            visibility: 'visible', transformOrigin: '50% 50%', 
            scale: 1 
        })
   
        .to('#bullseyeDot1', 2, { scale: 1, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot1', 1.5, { scale: 0, ease: Bounce.easeOut}, 2)

        .to('#bullseyeDot2', 2.6, { scale: 1, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot2', 0.9, { scale: 0, ease: Bounce.easeOut}, 2.6)

        .to('#bullseyeDot3', 1.9, { scale: 0, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot3', 1.6, { scale: 1, ease: Bounce.easeOut}, 1.9)

        .to('#bullseyeDot6', 1.4, { scale: 0, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot6', 2.1, { scale: 1, ease: Bounce.easeOut}, 1.4)

        .to('#bullseyeDot5', 1.6, { scale: 1, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot5', 1.5, { scale: 0, ease: Bounce.easeOut}, 1.6)
        .to('#bullseyeDot5', 0.4, { scale: 0.5, ease: Linear.easeNone}, 3.1)

        .to('#bullseyeDot4', 1.3, { scale: 0, ease: Bounce.easeOut}, 0)
        .to('#bullseyeDot4', 1.7, { scale: 1, ease: Bounce.easeOut}, 1.3)
        .to('#bullseyeDot4', 0.5, { scale: 0.5, ease: Linear.easeNone}, 3)

    animateBullseyeDots.timeScale(1.5).play(1);


   /**
    * Scene Four
    */
    const animateServerLight = new TimelineMax({repeat: -1});
    const sceneThreeClockHands = new TimelineMax({repeat: -1});
    const sceneThreeClockHandHour = new TimelineMax({repeat: -1});
    const sceneThreeClockHandMinute = new TimelineMax({repeat: -1});

    animateServerLight.to('#greenLight', 0.3, {fill: '#2de838'})
      .to('#greenLight', 0.3, {fill: '#3A913F'}, '+=1');

    sceneThreeClockHandHour.set('#clockArmHour_1_', {transformOrigin: '50% 50%'})
    .to('#clockArmHour_1_', 12, {rotation: 360, ease: Power0.easeNone});

    sceneThreeClockHandMinute.set('#clockArmMinute_1_', {transformOrigin: '50% 50%'})
    .to('#clockArmMinute_1_', 1, {rotation: 360, ease: Power0.easeNone});

    sceneThreeClockHands.add(sceneThreeClockHandHour, 0)
    .add(sceneThreeClockHandMinute, 0);

  /**
   * Scene Five
   */
    const animateScales = new TimelineMax({repeat: -1});
    const animateScalesTiltLeftUp = new TimelineMax();
    const animateScalesTiltRightUp = new TimelineMax();
    const animateDatabases = new TimelineMax({repeat: -1, repeatDelay: 1});
    const animatePieChartCombineSlice = new TimelineMax();
    const animatePieChartSeparateSlice = new TimelineMax();
    const animateArrow = new TimelineMax({repeat: -1, repeatDelay: 1});
    const ease = Power0.easeNone;
    const swingDuration = 2;

    animatePieChartCombineSlice.to('#pieSlice', swingDuration, {y: 29, x: -17, opacity: 1});
    animatePieChartSeparateSlice.to('#pieSlice', swingDuration, {y: 0, x: 0, opacity: 0});

    animateScalesTiltLeftUp.to('#scalesLine', swingDuration, {rotation: 5, ease: ease}, 0)
      .to('#ipad', swingDuration, {y: -35, x: 10, rotation: 5, ease: ease}, 0)
      .to('#currencyPieChart', swingDuration, {y: 39, ease: ease}, 0)
      .add(animatePieChartCombineSlice, 0);

    animateScalesTiltRightUp.to('#scalesLine', swingDuration, {rotation: -5, ease: ease}, 0)
      .to('#ipad', swingDuration, {y: 39, x: -10, rotation: -5, ease: ease}, 0)
      .to('#currencyPieChart', swingDuration, {y: -42, ease: ease}, 0)
      .add(animatePieChartSeparateSlice, 0);

    animateDatabases.set('#dbs #db1', {visibility: 'visible', y: 120})
      .set('#dbs #db2', {x: -45})
      .set('#dbs #db3', {x: -67})
      .to('#dbs #db1', 0.333, {visibility: 'visible', y: 0})
      .to('#dbs #db2', 0.333, {visibility: 'visible', x: 0})
      .to('#dbs #db3', 0.333, {x: -20}, '-=0.5')
      .to('#dbs #db3', 0.333, {visibility: 'visible', x: 0})
      .to('#dbs #db3', 0.333, {x: -30}, '+=1')
      .set('#dbs #db3', {visibility: 'hidden'})
      .to('#dbs #db2', 0.333, {x: -45})
      .to('#dbs #db3', 0.333, {x: -67}, '-=0.5')
      .set('#dbs #db2', {visibility: 'hidden'})
      .to('#dbs #db1', 0.333, {y: 120});

    animateArrow.set('#arrow #line', {strokeDasharray: 280, strokeDashoffset: 280, opacity: 1})
      .to('#arrow #line', 0.5, {strokeDashoffset: 0})
      .to('#arrowEnd path', 0.5, {transformOrigin: '80% 0%', scale: 6})
      .to(['#fromthissize', '#arrowPoint'], 0.2, {opacity: 1}, '-=0.5')
      .to('#arrowEnd path', 0.5, {scale: 1}, '+=1')
      .to(['#fromthissize', '#arrowPoint'], 0.2, {opacity: 0}, '-=0.2')
      .to('#arrow #line', 0.5, {strokeDashoffset: 260});

    animateScales.set('#scalesLine', {transformOrigin: '50% 50%', rotation: -5, ease: ease})
      .set('#ipad', {transformOrigin: '50% 50%', y: 39, x: -10, rotation: -5, ease: ease})
      .set('#currencyPieChart', {transformOrigin: '55% 50%', y: -42, ease: ease})
      .add(animateScalesTiltLeftUp)
      .add(animateScalesTiltRightUp);

  /**
   * Scene Six
     */
    const s6Ease = Power2.easeOut;

    const animateTabletTapMaster = new TimelineMax({ repeat: -1, repeatDelay: 1 });
    animateTabletTapMaster
        .set('#tabletHand', { transformOrigin: '50% 50%', visibility: 'visible', x: '-=0', scale: 1.2})
        .set('#tabletCircles', { transformOrigin: '50% 50%', scale: 0 })
        .set(['#TouchSwipePieChart2', '#TouchSwipeBars', '#TouchSwipeGraph'], { visibility: 'visible', x: '-=150' })
        
        // first item
        .to('#tabletHand', 0.2, { x: 0, scale: 1, ease: Power2.easeIn })
        .add('tapDown1')
        .to('#tabletHand', 0.2, { x: '-=0', scale: 1.2, ease: Power2.easeIn }, 'tapDown1+=0.05')
        .to('#tabletCircles', 0.2, { visibility: 'visible', scale: 1, ease: Back.easeOut.config(1.5) }, 'tapDown1+=0.05')
        .to('#tabletCircles', 0.1, { scale: 0, ease: Linear.easeNone }, 'tapDown1+=0.25')
        .to('#TouchSwipePieChart', 1, { x: '+=150', opacity: 0, ease: s6Ease }, 'tapDown1+=0.25')
        .to('#TouchSwipeBars', 1, { x: 0, ease: s6Ease }, 'tapDown1+=0.25')

        // second item
        .to('#tabletHand', 0.2, { x: 0, scale: 1, ease: Power2.easeIn }, '+=1')
        .add('tapDown2')
        .to('#tabletHand', 0.2, { x: '-=0', scale: 1.2, ease: Power2.easeIn }, 'tapDown2+=0.05')
        .to('#tabletCircles', 0.2, { visibility: 'visible', scale: 1, ease: Back.easeOut.config(1.5) }, 'tapDown2+=0.05')
        .to('#tabletCircles', 0.1, { scale: 0, ease: Linear.easeNone }, 'tapDown2+=0.25')
        .to('#TouchSwipeBars', 1, { x: '+=150', opacity: 0, ease: s6Ease }, 'tapDown2+=0.25')
        .to('#TouchSwipeGraph', 1, { x: 0, ease: s6Ease }, 'tapDown2+=0.25')

        // third item
        .to('#tabletHand', 0.2, { x: 0, scale: 1, ease: Power2.easeIn }, '+=1')
        .add('tapDown3')
        .to('#tabletHand', 0.2, { x: '-=0', scale: 1.2, ease: Power2.easeIn }, 'tapDown3+=0.05')
        .to('#tabletCircles', 0.2, { visibility: 'visible', scale: 1, ease: Back.easeOut.config(1.5) }, 'tapDown3+=0.05')
        .to('#tabletCircles', 0.1, { scale: 0, ease: Linear.easeNone }, 'tapDown3+=0.25')
        .to('#TouchSwipeGraph', 1, { x: '+=150', opacity: 0, ease: s6Ease }, 'tapDown3+=0.25')
        .to('#TouchSwipePieChart2', 1, { x: 0, ease: s6Ease }, 'tapDown3+=0.25')


    if (!detectIE()) {

        // animate the clouds
        $$('.floating-cloud').forEach(el => {
            
            const animateBackgroundClouds = TweenMax.to(el, 1,
                { y: '+=100%', ease: Linear.easeNone }
            );
            
            scenes.push(
                new ScrollMagic.Scene({
                    triggerElement: el,
                    triggerHook: 1,
                    duration: defaults.imageDuration()
                }).setTween(animateBackgroundClouds)
            );
        })


    }


    


    /**
     * Summary Scene
     */
    
    const summaryAnimation = new TimelineMax();
    summaryAnimation.set('#txt1', { attr : { 'width' : 0 } })
    .set('#txt2', { attr : { 'width' : 0 } })
    .set('#txt3', { attr : { 'width' : 0 } })
    .to('#txt1', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0)
    .to('#txt2', 0.25, { attr : { 'width' : 69 }, ease: Power2.easeInOut }, 0.15)
    .to('#txt3', 0.25, { attr : { 'width' : 48 }, ease: Power2.easeInOut }, 0.3);

    // animate the quote marks (not on a scene as will move constantly)    
    const animateQuotes = new TimelineMax({repeat: -1});
    animateQuotes.fromTo('#clippedQuotes', 2, { x : 0 }, { x : '-36%', ease: Linear.easeNone }, 0);

    const sceneSummary = new ScrollMagic.Scene({
        triggerElement: '#summary_trigger',
        offset: defaults.offset()
    }).setTween(summaryAnimation);

    // add it to our scenes holder
    scenes.push(sceneSummary);

    // add our scenes to our scroll magic container
    scroll.addScene(scenes);


}



document.addEventListener("DOMContentLoaded", function(event) { 
    
    if (detectIE()) {
        document.getElementsByTagName("body")[0].classList.add('ie');
        setHeightOfSVGContainers();
    }

    //prepareSVGs();
    
    setUpAnimations();

    window.on('resize', resizing);
    
});


function setHeightOfSVGContainers() {
    
    const containerWidth = h.getElementWidth('intro_trigger');

    // intro image is 0.6237 height of container width
    const introImageHeight = containerWidth * 0.6237;
    $('#intro_graphic_container').style.height = introImageHeight +'px';

    // set some SVG heights
    $('#BalanceScales').style.minHeight = '400px';
    $('#TouchSwipe').style.minHeight = '300px';
    $('#serverClockLock').style.minHeight = '300px';
    $('#s1t3').style.minHeight = '400px';
    $('#HourGlass').style.marginTop = '0';
    $('#SavingPennies').style.minHeight = '400px';
    $('#CloudWarehouse2').style.minHeight = '270px';
    $('#BarcodeScanner').style.minHeight = '270px';
    $('#serverBullseye').style.minHeight = '300px';


    // set the background size for the cloud box in Scene 3
    const topCloudRatio = 0.359;
    const bottomCloudRatio = 390 / 1920;
    const cloudWidth = containerWidth + 1;
    const topCloudHeight = containerWidth * topCloudRatio;
    const bottomCloudHeight = containerWidth * bottomCloudRatio;
    $('#s1r3').style.backgroundSize = `${cloudWidth}px ${topCloudHeight}px, ${cloudWidth}px ${bottomCloudHeight}px`;


}


function detectIE() {
  
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  // other browser
  return false;
}


// WEBPACK FOOTER //
// ./app/js/main.js